<template>
  <section class="table-content">
    <div :style="{'height':blockHeight+'px'}" style="overflow: auto">
      <el-row class="duty-item" v-for="item in tableData" :key="item.id">
        <el-col :span="3">
          <div class="duty-time">
            <div>-{{item.createTime.substring(0,4)}}-</div>
            <div>{{item.createTime.substring(5,10)}}</div>
          </div>
        </el-col>
        <el-col :span="21">
          <div class="duty-content" @click="handleItemClick(item.id)">
            <div class="content-title">{{item.title}}</div>
            <div v-html="item.content" class="content-detail"></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-pagination
      class="table-page"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
    </el-pagination>
  </section>
</template>
<script>
  import { portalDuty} from '@/api/restapi.js'
  export default {
    data () {
      return {
        blockHeight: (document.documentElement.clientHeight - 408),
        tableData: [],
        loading: false,
        pageInfo: {
          page: 1,
          total: 0,
          size: 10
        }
      }
    },
    mounted () {
      this.searchList()
    },
    methods: {
      handleItemClick (id) {
        this.$router.push('/portal/duty/detail?id='+id)
      },
      searchList () {
        this.loading = true
        portalDuty(this.pageInfo.page,this.pageInfo.size).then(res => {
          this.loading = false
          if(res.data.code===0){
            this.tableData = res.data.data.list
            this.pageInfo.total = res.data.data.total
          }else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        }).catch(err => {
          this.loading = false
        })
      },
      handleSizeChange (val) {
        this.pageInfo.size = val
        this.searchList()
      },
      handleCurrentChange (val) {
        this.pageInfo.page = val
        this.searchList()
      }
    }
  }
</script>
<style>
  .duty-item {
    border-bottom: 1px solid #888888;
    height: 80px;
    padding:10px 20px;
  }
  .duty-item .duty-time {
    text-align: center;
    width: 50px;
    margin-top: 8px;
    background: #aa051a;
    padding: 5px;
    border-radius: 4px;
    color: #FFFFFF;
    font-weight: 800;
    font-size: 14px;
  }
  .duty-item .content-title {
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space:nowrap;
  }
  .duty-item .content-detail{
    font-size: 13px;
    color: #666666;
    margin-top: 5px;
    height: 35px;
    overflow:hidden;text-overflow:ellipsis;white-space:nowrap;
  }
  .duty-item .content-detail p {
    margin: 0 auto;
    padding: 0;
  }
  .duty-item .duty-content{
    cursor: pointer;
  }
  .table-content {
    background: #ffffff;
    width: 100%;
    padding: 10px 10px 15px;
  }
  .table-content .table-page {
    margin-top: 10px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/DynamicDutyList.vue